// import store from 'store';
import actions from './actions'
/*
const STORED_TAGS = () => {
  const data = store.get(`app.tags`)
    // user[key] = typeof item !== 'undefined' ? item : storedUser[key]
  return data
}
*/
const initialState = {
  // ...STORED_TAGS({
  data: [],
  isFetching: false,
  isPooling: false,
  error: '',
  // })
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.START_POOLING: {
      return {
        ...state,
        isPooling: true,
      }
    }
    case actions.FETCH_TAGS: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }
    case actions.FETCH_TAGS_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
      }
    }
    case actions.FETCH_TAGS_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error,
      }
    }
    case actions.STOP_POOLING: {
      return {
        ...state,
        isPooling: false,
      }
    }
    case actions.TAG_SET_VALUE: {
      return {
        ...state,
        path: action.tagpath,
        value: action.tagvalue,
      }
    }
    default: {
      return state
    }
  }
}
